import { Component, EventEmitter, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { StepsSyncDialogComponent } from '../steps-sync-dialog/steps-sync-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-steps-header',
  templateUrl: './steps-header.component.html',
  styleUrls: ['./steps-header.component.scss'],
})
export class StepsHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialog_service: DialogService, private error_service: ErrorService) {}

  onSyncClick(): void {
    this.dialog_service
      .openDialog(StepsSyncDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.failure) {
          this.dialog_service.openErrorDialog(`Processamento fallito: ${dialog_result.failure_msg}`);
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
